<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteSupplierConfirm(form)" :vm-action="true" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="true" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("suppliers.name_placeholder")' :danger="!$v.form.name.minLength" :danger-text="'Name must have at least 5 ' + $v.form.name.$params.minLength + ' letters.'" v-model="form.name" :label='$t("suppliers.name")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("suppliers.contact_placeholder")' v-model="form.contact" :label='$t("suppliers.contact")' required)
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("suppliers.address_placeholder")' :danger="!$v.form.address.minLength" :danger-text="'Address must have at least 5 ' + $v.form.address.$params.minLength + ' letters.'" v-model="form.address" :label='$t("suppliers.address")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("suppliers.zipcode_placeholder")' v-model="form.zipcode" :danger="!$v.form.zipcode.required" :danger-text="'Zipcode is required '" :label='$t("suppliers.zipcode")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          label {{$t("suppliers.has_rfc")}}
          vm-switch(v-model="form.has_rfc" @change="fillRfc")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          label {{$t("suppliers.direct_shipping")}}
          vm-switch(v-model="form.direct_shipping")
      vm-col(v-if="!form.has_rfc" vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("suppliers.rfc_placeholder")' :danger-text="'RFC must have at least 10 ' + $v.form.rfc.$params.minLength + ' letters.'" v-model="form.rfc" :label='$t("suppliers.rfc")')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("suppliers.phone_placeholder")' :danger="!$v.form.phone.minLength" :danger-text="'Phone must have at least 8 ' + $v.form.phone.$params.minLength + ' letters.'" v-model="form.phone" :label='$t("suppliers.phone")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("suppliers.country_placeholder")' :danger="!$v.form.country" :danger-text="'Country is required'" v-model="form.country" :label='$t("suppliers.country")')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-select(url="addresses" column="address" :placeholder='$t("suppliers.billing_address_id_placeholder")' :danger="!$v.form.billing_address_id.numeric" :danger-text="'Billing Address is required.'" v-model="form.billing_address_id" :label='$t("suppliers.billing_address_id")' @input-change="autoCompleteFunc")
            vm-select-item(:key="index" :value="item.id" :text="item.address" v-for="(item,index) in suppliersCatalog.addresses")
</template>

<script>
import { required, requiredIf, minLength, numeric } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Suppliers')

export default {
  name: 'ModalSuppliers',
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    isAdd: {
      default: true,
      type: Boolean
    }
  },
  validations () {
    return {
      form: {
        name: {
          required,
          minLength: minLength(5)
        },
        address: {
          required,
          minLength: minLength(5)
        },
        zipcode: {
          required
        },
        rfc: {
          required: requiredIf((rfc) => {
            return !this.form.has_rfc
          })
        },
        phone: {
          required,
          minLength: minLength(8)
        },
        country: {
          required
        },
        billing_address_id: {
          numeric,
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'isModalVisible',
      'suppliersCatalog'
    ]),
    getTitle () {
      return this.isAdd ? this.$t('suppliers.add') : this.$t('suppliers.edit')
    }
  },
  async created () {
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'addSupplier',
      'editSupplier',
      'deleteSupplier',
      'setModalVisible',
      'loadCatalog'
    ]),
    saveRecord () {
      this.isAdd ? this.addSupplier(this.form) : this.editSupplier(this.form)
    },
    async deleteSupplierConfirm (supplier) {
      let t = this
      this.auxDeleteSupplier = () => {
        t.deleteSupplier(supplier)
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { attribute: this.$t(supplier.rfc) }),
        accept: this.auxDeleteSupplier
      })
    },
    async getCatalog () {
      Object.keys(this.suppliersCatalog).forEach(e => this.loadCatalog({ url: e, filter: '' }))
    },
    autoCompleteFunc (value) {
      let payload = {}
      let column = value.target.parentElement.parentElement.getAttribute('column')
      let param = value.srcElement.value
      payload.url = value.target.parentElement.parentElement.getAttribute('url')
      payload.filter = `?${column}=*${param}*&order_by=${column},asc`
      this.loadCatalog(payload)
    },
    close () {
      this.setModalVisible(false)
    },
    fillRfc () {
      this.form.rfc = 'n/a'
    }
  }
}
</script>

<style>
.vm-select--options {
  z-index: 400331 !important;
}
</style>
